<template>
  <span>
    <svg v-if="type === 'icon-folder'" t="1746684043954" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1523" :width="width" :height="height">
      <path d="M1013.55102 308.825397v590.947846c0 38.312925-31.346939 69.659864-69.659864 69.659864H80.108844c-38.312925 0-69.659864-31.346939-69.659864-69.659864V308.825397h1003.10204z" fill="#FFBF00" p-id="1524"></path><path d="M943.891156 130.031746h-461.478022l-21.334495-66.135075C457.159111 51.738703 443.501134 41.795918 430.730159 41.795918h-250.77551c-12.770975 0-26.131737 10.035664-29.693678 22.300445L131.11844 130.031746H80.108844C41.795918 130.031746 10.44898 161.378685 10.44898 199.69161v109.133787h1003.10204V199.69161c0-38.312925-31.346939-69.659864-69.659864-69.659864z" fill="#FFD554" p-id="1525"></path>
    </svg>
    <svg v-else-if="type === 'icon-file'" t="1746684593238" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8549" :width="width" :height="height">
      <path d="M862 902c0 16.569-13.431 30-30 30H192c-16.569 0-30-13.431-30-30V122c0-16.569 13.431-30 30-30h476l194 194v616z" fill="#4895FF" p-id="8550"></path>
      <path d="M862 286H698c-16.569 0-30-13.431-30-30V92" fill="#FFFFFF" fill-opacity=".296" p-id="8551"></path>
      <path d="M290 349m37 0l224.931 0q37 0 37 37l0 0q0 37-37 37l-224.931 0q-37 0-37-37l0 0q0-37 37-37Z" fill="#FFFFFF" p-id="8552"></path>
      <path d="M290 511m37 0l370 0q37 0 37 37l0 0q0 37-37 37l-370 0q-37 0-37-37l0 0q0-37 37-37Z" fill="#FFFFFF" p-id="8553"></path>
      <path d="M290 673m37 0l370 0q37 0 37 37l0 0q0 37-37 37l-370 0q-37 0-37-37l0 0q0-37 37-37Z" fill="#FFFFFF" p-id="8554"></path>
    </svg>
    <i
      v-else
      :class="type"
      class="iconfont"
      :style="{ width: width + 'px', height: height + 'px' }"
    />
  </span>
</template>

<script>
export default {
  name: 'DyTreeIcon',
  props: {
    type: {
      Object: String,
      default: 'ORG'
    },
    width: {
      Object: [String, Number],
      default: '14'
    },
    height: {
      Object: [String, Number],
      default: '14'
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped></style>
